import { render, staticRenderFns } from "./kka_sppd.vue?vue&type=template&id=8d4d55ce&"
import script from "./kka_sppd.vue?vue&type=script&lang=js&"
export * from "./kka_sppd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QIcon,QBtnGroup,QPagination,QDialog,QFile,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QIcon,QBtnGroup,QPagination,QDialog,QFile,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
